module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-mail-10f94b6272acb54cadb303920548c7bf.svg";